export const HEADER_MENU_HEIGHT = 68; /* sync with var(--header-height) */

export const NOTIFICATIONS = {
    ACK_REQUIRE: 'ack_require',
    ACK_CANCEL: 'ack_cancel',

    WS_ADD_USER: 'ws_add_user',
    WS_REMOVE_USER: 'ws_remove_user',

    DOC_PAGE_MENTION: 'doc_page_mention',
    DOC_COMMENT_MENTION: 'doc_comment_mention',
    DOC_COMMENT_REPLAY: 'doc_comment_replay',
    DOC_COMMENT_TREAD: 'doc_comment_tread',
    DOC_COMMENT_RESOLVED: 'doc_comment_resolved',

    QUIZ_REQUIRE: 'quiz_require',
    QUIZ_RETAKE: 'quiz_retake',
    QUIZ_CANCEL: 'quiz_cancel',

    ITEM_TRASH_ON: 'item_trash_on',
    ITEM_TRASH_OFF: 'item_trash_off',
    ITEM_ARCHIVE_ON: 'item_archive_on',
    ITEM_ARCHIVE_OFF: 'item_archive_off',

    USER_ROLE_CHANGE: 'user_role_change',
    USER_JOIN: 'user_join',
}
